import * as React from 'react';
import { reduxDispatcher } from 'lib/Dispatcher';
// @ts-ignore
import { addModal, removeModal } from 'reducers/modals';

import ModalPrefetcher from 'components/ModalPrefetcher';

/* This is deprecated, please use the following:
 *
 * import Modal from 'react-modal';
 * 
 * class Foo extends React.Component {
 *   state = {
 *     modal: true,  
 *   }
 * 
 *   openModal = () => this.setState({ modal true })}
 *   closeModal = () => this.setState({ modal false })}
 *   
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={this.openModal}>
 *           click to open modal
 *         </button>
 *         <Modal isOpen={this.state.modal}>
 *           <Dialog onRequestHide={this.closeModal}>
 *             some dialog content
 *           </Dialog>
 *         </Modal>
 *       </div>
 *     );
 *   }
 * }
 * 
 * And be wary, it is not possible to open modals inside layers
 * like tooltips / hovercards since the layer might disapear and
 * the modal unmounted! In this case you should pull the opening of
 * the modal into the parent component.
 *  
 */
export function mountModal(modal: any, _deprecatedParent: any) {
  const prefetchedModal = <ModalPrefetcher onRequestHide={() => {}} modal={modal} />;

  const controller = {
    mount: () => reduxDispatcher.dispatch(addModal(prefetchedModal)),
    unmount: () => reduxDispatcher.dispatch(removeModal(prefetchedModal)),
  };

  controller.mount();
  return controller.unmount;
}
